import React from 'react';
import ReactDOM from 'react-dom';
import { Route, Switch, HashRouter as Router } from 'react-router-dom';
import './index.css';
import './vendor/bootstrap/css/bootstrap.min.css';
import './css/business-frontpage.css';
import * as serviceWorker from './serviceWorker';
import YourJourney from "./components/yourJourney/yourJourney";
import NavBar from "./components/basic/NavBar";
import Footer from "./components/basic/Footer";
import NoMatch404 from "./components/basic/NoMatch404";
import Home from "./components/home/Home";
import ProfessionalDevelopment from "./components/professional-development/ProfessionalDevelopment";
import Enroll from "./components/enroll-for-course/Enroll";
import JoinUs from "./components/join-us/JoinUs";
import EnggCourses from "./components/engg-courses/EnggCourses";
import RemoteInternships from "./components/remoteInternships/remoteInternships";

const routing = (
    <Router basename={process.env.PUBLIC_URL}>
        <NavBar />
        <div>
            <Switch>
                <Route exact path="/" component={Home} />
                <Route path="/shareYourJourney" component={YourJourney} />
                <Route path="/professionalDevelopment" component={ProfessionalDevelopment} />
                <Route path="/engineeringCourses" component={EnggCourses} />
                <Route path="/enroll/:program/:course" component={Enroll} />
                <Route path="/joinUs" component={JoinUs} />
                <Route path="/remoteInternships" component={RemoteInternships} />
                <Route component={NoMatch404} />
            </Switch>
        </div>
        <Footer />
    </Router>
);
ReactDOM.render(routing, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
